import request from '@/utils/request'

// 获取客户列表
export function getCustomerList(data) {
  return request({
    url: '/move/getCustomersList',
    method: 'post',
    data
  })
}

// 添加客户
export function addCustomer(data) {
  return request({
    url: '/move/addCustomers',
    method: 'post',
    data
  })
}

// 更新客户信息
export function updateCustomer(data) {
  return request({
    url: `/move/addCustomersWin`,
    method: 'post',
    data
  })
}

// 删除客户
export function deleteCustomer(id) {
  return request({
    url: `/api/customers/${id}`,
    method: 'delete'
  })
} 

export function getCustomerListSta(data) {
  return request({
    url: '/move/getCustomersListSta',
    method: 'post',
    data
  })
}

// 添加客户
export function addCustomerSta(data) {
  return request({
    url: '/move/addCustomersSta',
    method: 'post',
    data
  })
}

// 更新客户信息
export function updateCustomerSta(data) {
  return request({
    url: `/move/addCustomersWinSta`,
    method: 'post',
    data
  })
}

export function customersApproval(data) {
  return request({
    url: `/move/customersApproval`,
    method: 'post',
    data
  })
}


export function getCustomersInfo(params) {
  return request({
    url: `/move/getCustomersInfo`,
    method: 'get',
    params
  })
}